import axios from '../../api/axiosClient';

export const addToCart = async (compositionId, quantity = 1) => {
  const response = await axios.post('/api/cart/add_to_cart/', {
    composition_id: compositionId.toString(),
    quantity: quantity,
  });
  return response.data.count;
};

export const fetchCartCount = async () => {
  const response = await axios.get('/api/cart/count/');
  return response.data.count;
};

const api = {
  addToCart,
  fetchCartCount,
};

export default api;
